import { reportEntities } from './types';

export const requestReportEntities = () => ({
  type: reportEntities.request,
});
export const requestReportEntitiesSuccess = (response) => ({
  type: reportEntities.success,
  response,
});
export const requestReportEntitiesFailure = (error) => ({
  type: reportEntities.failure,
  error,
});
